import LiveEffect from './LiveEffect.js';
import {isNumber} from 'utils/IsNumber.js';
import ParameterContext from 'effects/ParameterContext.js';
import RackMacro from 'effects/RackMacro.js';
import {MACROS_EFFECT} from './constants.js';
import {PARAMS_TO_IGNORE} from 'effects/midi/mappable/getTrackParameters.js';

const DEFAULT_MACROS = 6;

class MacrosEffect extends LiveEffect {
    constructor(track) {
        super('Macros', MACROS_EFFECT, track);

        this.macros = [];

        // start with 4 macros by default
        for (let i=0; i < DEFAULT_MACROS; i++) {
            this.newMacro();
        }

        this.randomness = 15;
    }

    getParameters() {
        return this.macros.map(
            m => m.macroParameter);
    }

    newMacro() {
        this.macros.push(
            new RackMacro(
                "Macro " + (this.numMacros + 1),
                this.track.sequencerEngine,
                this.context));
    }

    get context() {
        return new ParameterContext()
            .forLiveEffect(this)
            .forTrack(this.track);
    }

    get numMacros() {
        return this.macros.length;
    }

    getJson() {
        let json = super.getJson();

        return {
            ... json,
            macros: this.macros.map(
                m => m.getJson())
        };
    }

    getLFOParameters() {
        return [];

        /*
        let parameters = [];
        let lfos = this.track.sequencerEngine.lfos.map(x => x.lfo);
        for (let lfo of lfos) {
            parameters = [
                ... parameters,
                ... lfo.parameters
            ];
        }
        return parameters;
        */
    }

    fromJson(json) {
        super.fromJson(json);

        this.ripMods();

        let parameters = [
            ...this.track.getAllParameters(),
            ...this.getLFOParameters()
        ];
                          
        for (let i in this.macros) {
            this.macros[i].fromJson(json.macros[i], parameters);
        }
    }

    getCopy(track) {
        let copied = new MacrosEffect(track);
        copied.fromJson(this.getJson());
        return copied;
    }

    dispose() {
        // this.macros.forEach(m => m.ripMods());
        this.macros.forEach(
            m => m.unmapAllParameters());
        this.macros = undefined;
    }

    ripMods() {
        this.macros.forEach(m => m.ripMods());
    }

    generateMappings() {
        this.macros.forEach(
            m => m.unmapAllParameters());
       
        let parameters = [
            ... this.track.effectsChain.getAllParameters(),
            ... this.track.midiEffects.getAllParameters(),
            ... this.getLFOParameters()];
        if (this.track.instrument) {
            parameters = [
                ... parameters,
                ... this.track.instrument.getParameters()
            ];
        }

        for (let param of parameters) {
            if (Math.random() > this.randomness / 100.0 || !param.automatable ||
                PARAMS_TO_IGNORE.includes(param.name)) {
                continue;
            }
            let min = param.get(true);
            let max = min + (this.randomness/100.0)*Math.random() * (param.max - min)
            if (Math.random() < 0.5) {
                max = min - (this.randomness/100.0)*Math.random() * (min - param.min)
            }
            let macro = this.macros[Math.floor(Math.random() * this.macros.length)];
            if (isNumber(min)) {
                macro.addParameter(param, min, max);
            }
        }
        this.macros.forEach(
            macro => macro.macroParameter.set(macro.macroParameter.get()));
    }
}

export default MacrosEffect;
